import React from "react";
import { ButtonBase } from "@mui/material";

export const BiggerButton = ({ icon, onClick, subtitle, title }) => (
  <ButtonBase className="bigger-button-base" onClick={onClick}>
    <div className="big-button-icon">
      <img src={icon} />
    </div>
    <div>
      <h2>{title}</h2>
    </div>
    <div>
      <span>{subtitle}</span>
    </div>
  </ButtonBase>
);
